import React from 'react';
import { Typography, CircularProgress } from '@mui/material';
import AppDialog from './AppDialog';

/*
  ConfirmDialog: the single confirmation dialog for the app — built on
  AppDialog so it inherits the clean header, radius, padding and stacked
  footer. Replaces the many hand-rolled "Are you sure?" delete dialogs that
  each styled themselves slightly differently.

  Props:
   - open / onClose: standard wiring (onClose also cancels)
   - title: header text (e.g. "Delete Rule")
   - message: string or node shown in the body
   - confirmLabel / confirmColor: primary action (defaults to a red "Delete")
   - cancelLabel: quiet secondary action (defaults to "Cancel")
   - onConfirm: fired by the primary button
   - loading: shows a spinner on the primary button and blocks re-clicks
*/
export default function ConfirmDialog({
  open,
  onClose,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Delete',
  confirmColor = 'error',
  onConfirm,
  cancelLabel = 'Cancel',
  loading = false,
}) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={title}
      primaryLabel={loading ? <CircularProgress size={18} color="inherit" /> : confirmLabel}
      onPrimary={onConfirm}
      primaryColor={confirmColor}
      primaryDisabled={loading}
      secondaryLabel={cancelLabel}
      onSecondary={onClose}
    >
      {typeof message === 'string' ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {message}
        </Typography>
      ) : (
        message
      )}
    </AppDialog>
  );
}
